type StorageValue<T> = T | null;

type SessionStorageAccessMethods = {
    getSessionStorageValue: <T>(key: string) => StorageValue<T>;
    setSessionStorageValue: <T>(key: string, value: StorageValue<T>) => void;
    clearSessionStorageValue: (key: string) => void;
    replaceSessionStorageValue: <T>(key: string, value: StorageValue<T>) => void;
};

const useSessionStorage = (): SessionStorageAccessMethods => {
    const getSessionStorageValue = <T>(key: string): StorageValue<T> => {
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? (JSON.parse(item) as T) : null;
        } catch (error) {
            console.error(`Error reading sessionStorage key "${key}":`, error);
            return null;
        }
    };

    const setSessionStorageValue = <T>(key: string, value: StorageValue<T>): void => {
        try {
            window.sessionStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error(`Error setting sessionStorage key "${key}":`, error);
        }
    };

    const clearSessionStorageValue = (key: string): void => {
        try {
            window.sessionStorage.removeItem(key);
        } catch (error) {
            console.error(`Error clearing sessionStorage key "${key}":`, error);
        }
    };

    const replaceSessionStorageValue = <T>(key: string, value: StorageValue<T>): void => {
        clearSessionStorageValue(key);
        setSessionStorageValue(key, value);
    };

    return { getSessionStorageValue, setSessionStorageValue, clearSessionStorageValue, replaceSessionStorageValue };
};

export default useSessionStorage;
